import { Box, Typography, Button } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import logo from '../../assets/rounded_logo.svg'

export default function UtilRoomieBreakdownFrame() {
  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      {/* iPhone Frame */}
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          px: 1.5,
          pt: 1,
          pb: 0.5
        }}>
          <Box
            component="img"
            src={logo}
            alt="HeyyProperty"
            sx={{
              height: 40,
              width: 'auto',
              maxWidth: '60px',
              marginTop: '5px'
            }}
          />
        </Box>

        {/* Content */}
        <Box sx={{
          flex: 1,
          overflow: 'hidden',
          px: 1.5,
          pt: 0.5,
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Upcoming Card */}
          <Box sx={{
            border: '1px solid',
            borderColor: 'grey.200',
            borderRadius: '12px',
            p: 1.5
          }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.875rem', mb: 1 }}>
              Upcoming Bills
            </Typography>

            {/* Gas & Electric Bill (expanded) */}
            <Box sx={{
              border: '1px solid',
              borderColor: 'grey.200',
              borderRadius: '8px',
              overflow: 'hidden',
              mb: 1
            }}>
              {/* Summary row */}
              <Box sx={{ p: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ fontSize: '0.875rem' }}>🏠</Box>
                    <Typography sx={{ fontSize: '0.625rem', color: 'grey.700' }}>
                      Gas &amp; Electric
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Typography sx={{ fontSize: '0.625rem', fontWeight: 700, color: 'grey.900' }}>
                      Your share: $47.50
                    </Typography>
                    <ExpandLessIcon sx={{ fontSize: '0.875rem', color: 'grey.500' }} />
                  </Box>
                </Box>
                <Typography sx={{ fontSize: '0.5rem', fontWeight: 600, color: 'grey.500', mt: 0.5 }}>
                  Due Mar 1
                </Typography>
              </Box>

              {/* Expanded details */}
              <Box sx={{ borderTop: '1px solid', borderColor: 'grey.200', px: 1, py: 1 }}>
                <Typography sx={{ fontSize: '0.625rem', fontWeight: 600, color: 'grey.700', mb: 0.75 }}>
                  Roommates
                </Typography>

                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 0.5,
                  borderBottom: '1px solid',
                  borderColor: 'grey.100'
                }}>
                  <Typography sx={{ fontSize: '0.625rem', color: 'grey.800' }}>You</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <Typography sx={{ fontSize: '0.625rem', fontWeight: 700, color: 'grey.900' }}>$47.50</Typography>
                    <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Pending</Typography>
                  </Box>
                </Box>

                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 0.5,
                  borderBottom: '1px solid',
                  borderColor: 'grey.100'
                }}>
                  <Typography sx={{ fontSize: '0.625rem', color: 'grey.800' }}>Jacob Valkerie</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <Typography sx={{ fontSize: '0.625rem', fontWeight: 700, color: 'grey.900' }}>$47.50</Typography>
                    <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Pending</Typography>
                  </Box>
                </Box>

                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 0.5,
                  borderBottom: '1px solid',
                  borderColor: 'grey.100'
                }}>
                  <Typography sx={{ fontSize: '0.625rem', color: 'grey.800' }}>John Snow</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <Typography sx={{ fontSize: '0.625rem', fontWeight: 700, color: 'grey.900' }}>$47.50</Typography>
                    <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Pending</Typography>
                  </Box>
                </Box>

                <Typography sx={{ fontSize: '0.625rem', fontWeight: 700, color: 'grey.900', mt: 1 }}>
                  Total: $142.50
                </Typography>

                <Button
                  fullWidth
                  variant="outlined"
                  disableElevation
                  sx={{
                    borderColor: 'grey.300',
                    color: 'grey.800',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.625rem',
                    borderRadius: '9999px',
                    py: 0.5,
                    mt: 1,
                    '&:hover': { borderColor: 'grey.400' }
                  }}
                >
                  View Receipt
                </Button>

                <Button
                  fullWidth
                  variant="outlined"
                  disableElevation
                  sx={{
                    borderColor: 'grey.300',
                    color: 'grey.800',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.625rem',
                    borderRadius: '9999px',
                    py: 0.5,
                    mt: 0.75,
                    '&:hover': { borderColor: 'grey.400' }
                  }}
                >
                  Pay $47.50
                </Button>
              </Box>
            </Box>

            {/* Water Bill (collapsed) */}
            <Box sx={{
              border: '1px solid',
              borderColor: 'grey.200',
              borderRadius: '8px',
              p: 1
            }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Box sx={{ fontSize: '0.875rem' }}>💧</Box>
                  <Typography sx={{ fontSize: '0.625rem', color: 'grey.700' }}>
                    Water
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Typography sx={{ fontSize: '0.625rem', fontWeight: 700, color: 'grey.900' }}>
                    Your share: $22.00
                  </Typography>
                  <ExpandMoreIcon sx={{ fontSize: '0.875rem', color: 'grey.500' }} />
                </Box>
              </Box>
              <Typography sx={{ fontSize: '0.5rem', fontWeight: 600, color: 'grey.500', mt: 0.5 }}>
                Due Feb 27
              </Typography>
            </Box>

            {/* Internet Bill (collapsed) */}
            <Box sx={{
              border: '1px solid',
              borderColor: 'grey.200',
              borderRadius: '8px',
              p: 1,
              mt: 1
            }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Box sx={{ fontSize: '0.875rem' }}>🌐</Box>
                  <Typography sx={{ fontSize: '0.625rem', color: 'grey.700' }}>
                    Internet
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Typography sx={{ fontSize: '0.625rem', fontWeight: 700, color: 'grey.900' }}>
                    Your share: $20.00
                  </Typography>
                  <ExpandMoreIcon sx={{ fontSize: '0.875rem', color: 'grey.500' }} />
                </Box>
              </Box>
              <Typography sx={{ fontSize: '0.5rem', fontWeight: 600, color: 'grey.500', mt: 0.5 }}>
                Due Mar 5
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
